export const SET_PRODUCTS = 'FORCE_GUARANTEE/SET_PRODUCTS';
export const SET_PRODUCTS_LOADING = 'FORCE_GUARANTEE/SET_PRODUCTS_LOADING';
export const SET_PRODUCTS_ERROR = 'FORCE_GUARANTEE/SET_PRODUCTS_ERROR';
export const SET_SEARCH = 'FORCE_GUARANTEE/SET_SEARCH';
export const SET_TRANSACTIONS = 'FORCE_GUARANTEE/SET_TRANSACTIONS';
export const SET_TRANSACTIONS_LOADING = 'FORCE_GUARANTEE/SET_TRANSACTIONS_LOADING';
export const SET_TRANSACTIONS_ERROR = 'FORCE_GUARANTEE/SET_TRANSACTIONS_ERROR';
export const SET_SELECTED_TRANSACTION = 'FORCE_GUARANTEE/SET_SELECTED_TRANSACTION';
export const SET_EVALUATION = 'FORCE_GUARANTEE/SET_EVALUATION';
export const SET_EVALUATION_LOADING = 'FORCE_GUARANTEE/SET_EVALUATION_LOADING';
export const SET_EVALUATION_ERROR = 'FORCE_GUARANTEE/SET_EVALUATION_ERROR';
export const CLEAR_EVALUATION = 'FORCE_GUARANTEE/CLEAR_EVALUATION';
export const SET_FORCE_RESULT = 'FORCE_GUARANTEE/SET_FORCE_RESULT';
export const SET_FORCE_LOADING = 'FORCE_GUARANTEE/SET_FORCE_LOADING';
export const SET_FORCE_ERROR = 'FORCE_GUARANTEE/SET_FORCE_ERROR';
export const SET_MODAL_OPEN = 'FORCE_GUARANTEE/SET_MODAL_OPEN';
export const RESET = 'FORCE_GUARANTEE/RESET';
